/**
 * @NApiVersion 2.x
 * @NModuleScope TargetAccount
 */
define([
  'N/https',
  'N/search',
  'N/url'
], function (
  https,
  search,
  url
) {
	'use strict';

  var fileName = 'PartLookupSearcher.Backend.Model';
  var fnName = '';
  var brandCodes = [
    {
      brandName: 'Whirlpool',
      brandCode: 'WHI'
    },
    {
      brandName: 'Electrolux',
      brandCode: 'FRI'
    },
    {
      brandName: 'GE',
      brandCode: 'GE'
    }
  ];
  var apiEndpointUrl = '';

  function _createBrandedRequests(path, brandData, searchValue, isModelSearch) {

    var fnName = '_createBrandedRequests';
    var returnData = [];

    try {

      var partLookupEndpoint = _fetchPartsLookupEndpoint();

      if ( !partLookupEndpoint ) {
        return returnData;
      }

      // if we're getting data for a single brand
      if ( !!brandData ) {

        returnData.push(_createRequestHelper(
          partLookupEndpoint,
          path,
          brandData,
          searchValue,
          isModelSearch
        ));

      }

      // if we're getting data for each brand
      else {

        var l = brandCodes.length;

        for ( var i = 0; i < l; i++ ) {
          returnData.push(_createRequestHelper(
            partLookupEndpoint,
            path,
            brandCodes[i],
            searchValue,
            isModelSearch
          ));
        }
      }


    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return returnData;

  }

  function _createRequestHelper(partLookupEndpoint, path, brandData, searchValue, isModelSearch) {

    var fnName = '_createRequestHelper';
    var brandedRequest = {
      typeAheadRequest: {},
      brandData: brandDatad
    }

    try {

      var numResults = isModelSearch ? 25 : 50;
      // var numResults = isModelSearch ? 50 : 100;
      
      var page = 1;

      // /RestAPI/SearchModel/{brandCode}/{model}/{page}/{pageSize}

      var brandedPath = path + '/' + brandData.brandCode + '/' + searchValue;
      var typeAheadUrl = partLookupEndpoint + brandedPath + '/' + numResults;
      // var typeAheadUrl = partLookupEndpoint + brandedPath + '/' + page + '/' + numResults;
  
      var ariNetetPartsAppKey = https.createSecureString({
        input: '{custsecret_arinet_parts_appkey}',
      });
      
      brandedRequest.typeAheadRequest.url = typeAheadUrl;
      brandedRequest.typeAheadRequest.headers = {
        applicationKey: ariNetetPartsAppKey
      }

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return brandedRequest;
  }

  function _fetchPartsLookupEndpoint() {
    var fnName = '_fetchPartsLookupEndpoint';

    try {

      if ( !apiEndpointUrl ) {

        var ariNetBaseUrl = https.createSecureString({
          input:
            'https://servicesstg.arinet.com/PartStream/RestAPIEndPoint/?appkey=',
        });
    
        var ariNetAppKey = https.createSecureString({
          input: '{custsecret_airnet_appkey}',
        });
    
        // note - you cannot append a string to a secure string using native JS
        // you must use a NS method to concat regular strings w/ secure strings
        // see https://stackoverflow.com/questions/77440422/testing-secrets-in-netsuite-suitescript-for-api-keys
        // see https://docs.oracle.com/en/cloud/saas/netsuite/ns-online-help/section_4418286676.html#https.SecureString
        var secureApiEndpointUrl = ariNetBaseUrl.appendSecureString({
          secureString: ariNetAppKey,
        });

        var endpointLookupResponse = https.get({
          url: secureApiEndpointUrl
        });

        if ( !!endpointLookupResponse.body ) {
          apiEndpointUrl = endpointLookupResponse.body;
        }

      }

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return apiEndpointUrl;

  }

  // function _fetchTypeAheadResults(q, isModelSearch) {
    

  //   var fnName = '_fetchTypeAheadResults';
  //   var returnData = [];

  //   try {

  //     var basePath = '/RestAPI/';
  //     var type = isModelSearch ? 'ModelAutoComplete' : 'PartAutoComplete';
  //     // var type = isModelSearch ? 'SearchModel' : 'SearchPart';
  //     var path = basePath + type;

  //     var brandedRequests = _createBrandedRequests(
  //       path,             // path
  //       '',               // brandCode
  //       q,                // searchValue
  //       isModelSearch    // boolean
  //     );

  //     var l = brandedRequests.length;

  //     if ( !l ) {
  //       return returnData;
  //     }

  //     // make a request for each brandcode
  //     for ( var i = 0; i < l; i++ ) {

  //       var currentRequest = brandedRequests[i].typeAheadRequest;
  //       var currentBrandData = brandedRequests[i].brandData;
  //       var partLookupResponse = https.get(currentRequest);
  //       var body = JSON.parse(partLookupResponse.body);
  //       var data = body['Data'];

  //       log.debug('data', data);
  //       var ll = data.length;
        
  
  //       // for each brandcode, handle the results
  //       if ( !!ll ) {

  //         for ( var ii = 0; ii < ll; ii++ ) {

  //           var typeAheadResult = {
  //             isModel: isModelSearch,
  //             brandData: currentBrandData,
  //             Model: data[ii]['Model'],
  //             id: data[ii]['Model'],
  //             internalid: data[ii]['Model']
  //             // Part: ''
  //           };
            
            
  //           // if ( isModelSearch && data[ii].hasOwnProperty('Model') ) {
  //           //   typeAheadResult.modelName = data[ii]['Model'];
  //           // }
            
  //           // else if ( !isModelSearch && data[ii].hasOwnProperty('Part') ) {
  //           //   typeAheadResult.Part = data[ii]['part'];
  //           // }

  //           returnData.push(typeAheadResult);

  //         }
  //       }
  //     }

  //   } catch(error) {
  //     log.error(fileName + ' ' + fnName, error);
  //   }

  //   return returnData;
  // }

  function _fetchTypeAheadResults(q) {

    var fnName = '_fetchTypeAheadResults';
    var returnData = {
      total: 0,
      items: [],
      corrections: [],
      locale: {
        country: 'US',
        language: 'en',
        currency: 'USD',
        region: 1
      },
      backendType: 'OS',
      backend: 'E',
      links: [
        {
          rel: 'next',
          href: 'https://staging.appliancepartscompany.com/api/items?country=US&include=&pricelevel=5&c=4347112&offset=4&fieldset=modelsearch&language=en&sort=relevance%3Adesc&n=2&q=wtw&limit=4&use_pcv=F&currency=USD'
        }
      ],
      volatility: 'short',
      code: 200,
      warnings: {}
    };

    try {

      var endpoint = 'https://www.appliancepartscompany.com/api/cacheable/items';

      var params = {
        c: '4347112',
        country: 'US',
        currency: 'USD',
        fieldset: 'modelsearch',
        language: 'en',
        pricelevel: 5,
        n: '2',
        q: q
      };

      var itemSearchApiUrl = url.format({
        domain: endpoint,
        params: params,
      });

      var response = https.get({
        url: itemSearchApiUrl,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-SC-Touchpoint': 'shopping',
          'Accept': 'application/json',
          'Accept-encoding': 'gzip,deflate,sdch',
        },
      });

      if (response.body.toLowerCase() === 'not acceptable') {
        return returnData;
      }

      var body = JSON.parse(response.body);

      log.debug('body', body);

      if (body.hasOwnProperty('items')) {

        var filteredItems = [];
        var l = body.items.length;

        for ( var i = 0; i < l; i++ ) {

          log.debug('body.items[i]', body.items[i])

          if ( !!body.items[i]['custitem_sep_parent_model_number'] ) {
            filteredItems.push(body.items[i])
          }

        }

        returnData = body;
        returnData.items = filteredItems;
      }

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return returnData;
  }

  function _fetchPlpData(nsItems) {
    var fnName = '_fetchPlpData';
    var returnData = {
      hasItems: false,
      items: [],
    };

    try {

      var endpoint = 'https://www.appliancepartscompany.com/api/cacheable/items';
      var idFilters = '';
      var l = nsItems.length;

      for (var i = 0; i < l; i++) {
        idFilters += nsItems[i].nsInternalId;

        if (i !== l - 1) {
          idFilters += ',';
        }
      }

      var params = {
        id: idFilters,
        c: '4347112',
        country: 'US',
        currency: 'USD',
        fieldset: 'search',
        language: 'en',
        n: '2',
      };

      var itemSearchApiUrl = url.format({
        domain: endpoint,
        params: params,
      });

      var response = https.get({
        url: itemSearchApiUrl,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-SC-Touchpoint': 'shopping',
          'Accept': 'application/json',
          'Accept-encoding': 'gzip,deflate,sdch',
        },
      });

      if (response.body.toLowerCase() === 'not acceptable') {
        return returnData;
      }

      var body = JSON.parse(response.body);

      if (body.hasOwnProperty('items')) {
        returnData = {
          hasItems: true,
          items: body.items,
        };
      }

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return returnData;
  }

  function _populateAssemblyItems(assemblyParts, nsItems, plpItems) {
    var fnName = '_populateAssemblyItems';
    var returnData = assemblyParts;

    try {

      var l = returnData.length;

      for (var i = 0; i < l; i++) {
        var nsItem = _findObjectInArray(nsItems, 'sku', returnData[i]['Sku']);

        if (!!nsItem) {
          returnData[i].internalid = nsItem.nsInternalId;

          var plpItem = _findObjectInArray(
            plpItems,
            'internalid',
            nsItem['nsInternalId']
          );

          if (!!plpItem) {
            returnData[i].canPurchase = true;

            for (var prop in plpItem) {
              returnData[i][prop] = plpItem[prop];
            }
          } else {
            returnData[i].canPurchase = false;
          }
        } else {
          returnData[i].internalid = 0;
          returnData[i].canPurchase = false;
        }
      }

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return returnData;
  }

  function _searchForAssemblyPartsInNs(assemblyItems) {
    var fnName = '_searchForAssemblyPartsInNs';
    var returnData = [];

    try {
      var externalIdFilters = [];
      var l = assemblyItems.length;

      for (var i = 0; i < l; i++) {
        var sku = assemblyItems[i]['Sku'];

        if (!!sku) {
          externalIdFilters.push(['externalidstring', 'is', sku]);
          externalIdFilters.push('OR');
          externalIdFilters.push(['itemid', 'is', sku]);
          externalIdFilters.push('OR');
        }
      }

      externalIdFilters.pop();

      var itemSearchObj = search.create({
        type: 'item',
        filters: [
          ['isinactive', 'is', 'F'],
          'AND',
          ['isonline', 'is', 'T'],
          'AND',
          [externalIdFilters],
        ],
        columns: ['internalid', 'externalid', 'itemid'],
      });

      itemSearchObj.run().each(function (result) {
        var nsItemId = result.getValue({ name: 'itemid' });
        var nsItem = _findObjectInArray(assemblyItems, 'Sku', nsItemId);

        if (!!nsItem) {
          returnData.push({
            nsInternalId: result.id,
            sku: nsItemId,
          });

          return true;
        }

        var nsExternalId = result.getValue({ name: 'externalid' });
        nsItem = _findObjectInArray(assemblyItems, 'Sku', nsExternalId);

        if (!!nsItem) {
          returnData.push({
            nsInternalId: result.id,
            sku: nsExternalId,
          });
        }

        return true;
      });

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return returnData;
  }



  function _findObjectInArray(arr, key, value) {
    var fnName = '_findObjectInArray';
    var returnData = null;

    try {

      for (var i = 0; i < arr.length; i++) {
        if (arr[i][key] == value) {
          returnData = arr[i];
          break;
        }
      }

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return returnData;
  }


	return {

    getTypeAheadResults: function (request) {
			var q = request.parameters.q;

			// if search has no value
			if ( !q ) {
				throw {
          status: 401,
          message: 'Please provide a model number'
        }
			}

      // get the branded typeahead request urls
      var typeAheadResults = _fetchTypeAheadResults(q);
      // log.debug('typeAheadResults', typeAheadResults);

      // var partTypeAheadUrls = _fetchTypeAheadResults(q, false);
      // log.debug('partTypeAheadUrls', partTypeAheadUrls);

      // for models -

      // for parts, search items in item search api

      // return results
      return typeAheadResults;
		},

	};
});
